/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Box, Text, Flex } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { useMemo, useEffect, useState, useRef } from 'react';

// import TimeAggregationFilter from '../table/TimeAggregationFilter';
import {
  getAllInstrumentOutputs,
  getAllInstruments,
  setAllInstruments,
  updateInstrument,
  createInstrument,
  getSelectedDashboardScenario,
  getCompareDashboardScenario,
  getDashboardReportingPeriod,
  setEditInstrumentOutput,
  setEditInstrumentData,
  getEditInstrumentData,
  setAllInstrumentOutputs,
  getCalculationLoadingStatus,
  getTimeFilter,
} from 'redux/DashboardSliceV2';
import Spinner from 'components/Spinner';
import { AppDispatch, getRandomColor } from 'utils/GlobalHelpers';
import TabsFilter from 'pages/PlanPageOutputOptimization/Plan/Filters/TabsFilter';
import { STATUS } from 'projectConstants';

import PriviewFilterByComponent from '../PreviewFilterBy';
import TimeRangeFilter from '../TimeRangeFilter';
import EditableTitle from '../EditableTitle';

import PieChart from './PieChart';
import BarChart from './BarChart';
import LineChart from './LineChart';
import ComboChart from './ComboChart';

const ChartCard = ({ chartData, isDashboardLayout, isPreview }: any) => {
  const dispatch: AppDispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const allInstrumentsOutputs = useSelector(getAllInstrumentOutputs);
  const allInstruments = useSelector(getAllInstruments);
  const selectedDashboardScenario = useSelector(getSelectedDashboardScenario);
  const compareDashboardScenario = useSelector(getCompareDashboardScenario);
  const dashboardReportingPeriod = useSelector(getDashboardReportingPeriod);
  const timeFilter = useSelector(getTimeFilter);
  const editInstrumentData = useSelector(getEditInstrumentData);
  const calculationStatus = useSelector(getCalculationLoadingStatus);

  const timeGranularity =
    chartData?.time_granularity === 'month'
      ? 'M'
      : chartData?.time_granularity === 'quarter'
      ? 'Q'
      : 'Y';

  const isDimensionFilter = useMemo(() => {
    const indicatorsWithDimensions = chartData?.instrument_indicators?.filter((indicator: any) => {
      return (
        indicator?.formatting &&
        Array.isArray(indicator?.formatting?.dimensionItems) &&
        indicator?.formatting?.dimensionItems?.length > 1 &&
        indicator?.dimension_id !== null &&
        indicator?.dimension_id !== ''
      );
    });

    if (!indicatorsWithDimensions?.length) return false;

    const firstDimensionId: any = indicatorsWithDimensions[0]?.dimension_id;
    const allSameDimension = indicatorsWithDimensions.every(
      (indicator: any) => indicator?.dimension_id === firstDimensionId,
    );

    const actualIndicators = chartData?.instrument_indicators.filter(
      (indicator: any) => indicator.indicator_id,
    );

    const eachIndicatorHasSameDimension = actualIndicators.every(
      (indicator: any) => indicator?.dimension_id === firstDimensionId,
    );
    return (allSameDimension && eachIndicatorHasSameDimension) || false;
  }, [chartData?.instrument_indicators?.length, chartData?.instrument_indicators]);

  const handleTimeGranulirity = (value: any) => {
    const editData = JSON.parse(JSON.stringify(chartData));
    const newTimeGranularity =
      value === 'M' || value === 'm'
        ? 'month'
        : value === 'Q' || value === 'q'
        ? 'quarter'
        : 'year';
    if (editData.id) {
      const foundIndex = allInstruments.findIndex(
        (instrument: any) => instrument.id === editData.id,
      );
      if (foundIndex > -1 && !isPreview) {
        const list = JSON.parse(JSON.stringify(allInstruments));
        list[foundIndex].time_granularity = newTimeGranularity;
        dispatch(setAllInstruments([...list]));
        const reportingPeriod = dashboardReportingPeriod
          ? {
              preset: dashboardReportingPeriod.preset || 'Custom',
              start: dashboardReportingPeriod.start || '',
              end: dashboardReportingPeriod.end || '',
            }
          : null;
        const compareScenarioId = compareDashboardScenario?.id || null;
        dispatch(
          updateInstrument({
            request_body: {
              ...list[foundIndex],
              save: true,
              data_values: false,
              start_date: timeFilter?.start || '',
              end_date: timeFilter?.end || '',
              reporting_period: reportingPeriod,
              compare_scenario: compareScenarioId,
            },
          }),
        );
      }
    }
  };

  const handleApplyFilter = (filterAppliedData: any, filterItem: any) => {
    const widget = JSON.parse(JSON.stringify(chartData));

    if (selectedDashboardScenario && filterAppliedData?.length) {
      // Find all indicators that match the dimension_id
      const updatedIndicators = widget?.instrument_indicators?.map((indicator: any) => {
        if (indicator?.dimension_id === filterItem[0]?.dimensionId) {
          return {
            ...indicator,
            formatting: {
              ...indicator.formatting,
              dimensionItems: filterAppliedData
                .filter((item: any) => item.status)
                .map((item: any) => {
                  return {
                    dimension_item_id: item.dimension_item_id,
                    dimension_item_name: item.name,
                    color: getRandomColor(),
                  };
                }),
            },
          };
        }
        return indicator;
      });

      if (widget?.id) {
        const foundIndex = allInstruments.findIndex(
          (instrument: any) => instrument.id === widget.id,
        );
        if (foundIndex > -1 && !isPreview) {
          const list = JSON.parse(JSON.stringify(allInstruments));
          list[foundIndex].instrument_indicators = updatedIndicators;
          dispatch(setAllInstruments([...list]));
          const reportingPeriod = dashboardReportingPeriod
            ? {
                preset: dashboardReportingPeriod.preset || 'Custom',
                start: dashboardReportingPeriod.start || '',
                end: dashboardReportingPeriod.end || '',
              }
            : null;
          const compareScenarioId = compareDashboardScenario?.id || null;
          dispatch(
            updateInstrument({
              request_body: {
                ...list[foundIndex],
                save: true,
                data_values: true,
                start_date: timeFilter?.start || '',
                end_date: timeFilter?.end || '',
                reporting_period: reportingPeriod,
                compare_scenario: compareScenarioId,
              },
            }),
          ).then((result) => {
            dispatch(
              setAllInstrumentOutputs({
                ...allInstrumentsOutputs,
                [result.payload.id]: { ...result.payload.data },
              }),
            );
          });
        }
      }
    }
  };

  const blockId = useMemo(() => {
    if (chartData?.instrument_indicators) {
      const firstMetric = chartData.instrument_indicators[0];
      return firstMetric ? firstMetric.block_id : null;
    }
    return null;
  }, [chartData?.instrument_indicators]);

  const displayChart = () => {
    switch (chartData?.instrument_type) {
      // case 'pie':
      //   return (
      //     <PieChart chartFormatting={chartData?.formatting} graphData={chartData} />
      //     // <PieChart chartFormatting={chartData?.formatting} />
      //   );
      case 'line':
        return (
          <LineChart
            timeGranularityFilter={timeGranularity}
            chartFormatting={chartData?.formatting}
            graphData={allInstrumentsOutputs?.[chartData?.id]}
            isDashboardLayout={isDashboardLayout}
          />
        );
      case 'bar':
        return (
          <BarChart
            timeGranularityFilter={timeGranularity}
            chartFormatting={chartData?.formatting}
            graphData={allInstrumentsOutputs?.[chartData?.id]}
            isDashboardLayout={isDashboardLayout}
          />
        );
      case 'stack':
        return (
          <BarChart
            timeGranularityFilter={timeGranularity}
            chartFormatting={{ ...chartData?.formatting, stackBar: true }}
            graphData={allInstrumentsOutputs?.[chartData?.id]}
            isDashboardLayout={isDashboardLayout}
          />
        );
      case 'combi':
        return <ComboChart />;
      default:
        return <PieChart />;
    }
  };

  return (
    <>
      <Flex
        borderRadius='15px'
        flexDirection='column'
        border={isDashboardLayout ? '' : '1px solid #787878'}
        boxShadow={isDashboardLayout ? '' : '0px 4px 4px rgba(0, 0, 0, 0.25)'}
        height='100%'
      >
        {isLoading && (
          <Flex
            height='100%'
            direction='column'
            alignItems='center'
            justifyContent='center'
            w='full'
          >
            <Spinner styleProperties={{ my: '4vh' }} />
          </Flex>
        )}
        {!isLoading && (
          <>
            <Flex flexDirection='row' justifyContent='space-between' alignItems='center' m={1}>
              <Flex>
                {isDimensionFilter && (
                  <PriviewFilterByComponent
                    widget={chartData}
                    handleApplyFilter={handleApplyFilter}
                  />
                )}
              </Flex>
              <Flex>
                {timeGranularity && (
                  <TabsFilter
                    timeGranularity={timeGranularity}
                    onChangeSummeryMode={handleTimeGranulirity}
                    fontColor='#787878'
                    bg='#F7F7F815'
                    color='white'
                    selectedYear='all'
                    isDisabled={
                      !(calculationStatus === STATUS.SUCCESS || calculationStatus === STATUS.IDLE)
                    }
                  />
                )}
              </Flex>
            </Flex>
            <Flex justifyContent='center' alignItems='center' height='100%'>
              <Box
                className='dashboard-drag-header'
                cursor='grab'
                width={['bar', 'line', 'stack'].includes(chartData?.instrument_type) ? '95%' : ''}
                height={['bar', 'line', 'stack'].includes(chartData?.instrument_type) ? '97%' : ''}
              >
                {displayChart()}
              </Box>
            </Flex>
          </>
        )}
      </Flex>
    </>
  );
};

export default ChartCard;
